export default "__VITE_ASSET__BjkhFUDz__"